import axios from 'axios';

const toUkrName = (value) => `${value ?? ''}`.split('/')[0].trim();

export const getRegion = async () => {
  const url = '/reports/locations/';
  const response = await axios.get(url);
  return response;
};

export const getDistrict = async (region) => {
  const url = `/reports/locations/${toUkrName(region)}`;
  const response = await axios.get(url);
  return response;
};

export const getLocalCommunities = async (region, district) => {
  const url = `/reports/locations/${toUkrName(region)}/${toUkrName(district)}`;
  const response = await axios.get(url);
  return response;
};

export const getSettlement = async (region, district, community) => {
  const url = `/reports/locations/${toUkrName(region)}/${toUkrName(district)}/${toUkrName(community)}`;
  const response = await axios.get(url);
  return response;
};

export const getSettlementDetails = async (region, district, community, settlement, code) => {
  const url = `/reports/locations/code/${toUkrName(region)}/${toUkrName(district)}/${toUkrName(community)}/${toUkrName(settlement)}`;
  const response = await axios.get(url, code ? { params: { code } } : undefined);
  return response;
};
